// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__xlwoA","loading":"Loading_loading__yuBKz"};